export default [
    {
        header: 'PazarYerileri',
        icon: 'ShoppingBagIcon',
        children: [
            {
                title: 'Pazaryerleri',
                icon: 'ShoppingBagIcon',
                route: 'store',
            },
            {
                title: 'Ürünleri',
                icon: 'BoxIcon',
                route: 'store-product',
            },
            {
                title: 'Muhasebe',
                icon: 'BoxIcon',
                route: 'store-accounting',
            },
        ],
    }
]
